module.exports = __webpack_public_path__ + "static/img/course-package.4b613ac1.png";